import { render } from "./test-free-skeleton.vue?vue&type=template&id=21537b97&scoped=true"
import script from "./test-free-skeleton.vue?vue&type=script&lang=js"
export * from "./test-free-skeleton.vue?vue&type=script&lang=js"

import "./test-free-skeleton.vue?vue&type=style&index=0&id=21537b97&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21537b97"]])

export default __exports__